<template>
  <!-- 党建引领 -->
  <div>
    <div v-if="this.$route.path == '/pc/party'">
      <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 党建引领轮播图 -->
    <PartyBanner></PartyBanner>
    <!-- 智慧党建平台终端覆盖 -->
    <PartyTerminal></PartyTerminal>
    <!-- 核心功能 -->
    <PartyCore></PartyCore>
    <!-- 丰富多样的服务 -->
    <PartyServe></PartyServe>
    <!-- 党建要闻 -->
    <PartyDynamic></PartyDynamic>
    <!-- 底部导航 -->
    <BottomNav></BottomNav>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/pc/components/TopNav.vue";
import BottomNav from "../../../components/pc/components/BottomNav.vue";
import PartyBanner from '../../../components/pc/Party/PartyBanner.vue'
import PartyTerminal from '../../../components/pc/Party/PartyTerminal.vue'
import PartyCore from '../../../components/pc/Party/PartyCore.vue'
import PartyServe from '../../../components/pc/Party/PartyServe.vue'
import PartyDynamic from '../../../components/pc/Party/PartyDynamic.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    BottomNav,
    PartyBanner,
    PartyTerminal,
    PartyCore,
    PartyServe,
    PartyDynamic,
  },
};
</script>

<style scoped>
</style>
